// extracted by mini-css-extract-plugin
export var button = "_l1-0";
export var donut = "_l1-1";
export var donutFill = "_l1-3";
export var donutTrack = "_l1-2";